export default __webpack_public_path__ + "7955d68ed294fa3602d4536be4b7ab5b.png";